import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchSingleProductByCode } from "../../slice/productSlice";
import { addItems } from "../../slice/cartSlice";
import { getVendorIdFromToken } from "../../helpers/utils";
import { PageLoader } from "../../helpers/Loader";

const POST_LOGIN_REDIRECT_KEY = "postLoginRedirect";

const BuyNow = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasAddedRef = useRef(false);
  const {
    singleProductState: { loading, error },
  } = useSelector((state) => state.productLists);

  const productCode = searchParams.get("product_code") || "";
  const qtyParam = parseInt(searchParams.get("qty"), 10);
  const quantity = Number.isInteger(qtyParam) && qtyParam > 0 ? qtyParam : 1;

  useEffect(() => {
    const vendorId = getVendorIdFromToken();
    const decodedCode = decodeURIComponent(productCode);

    if (!decodedCode) {
      return;
    }

    if (!vendorId) {
      const redirectPath = `/buy-now?product_code=${encodeURIComponent(
        decodedCode
      )}&qty=${quantity}`;
      sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, redirectPath);
      navigate(`/auth?redirect=${encodeURIComponent(redirectPath.slice(1))}`);
      return;
    }

    dispatch(fetchSingleProductByCode({ productCode: decodedCode, vendorId }))
      .unwrap()
      .then((response) => {
        if (hasAddedRef.current) return;
        const productData = response?.data?.data?.productData;
        const productId = productData?.product?._id;
        if (!productId) return;

        hasAddedRef.current = true;
        dispatch(
          addItems({
            ...productData,
            quantity,
            buyNow: true,
            skipRedirect: true,
          })
        );
        navigate(
          `/checkout`,
          { replace: true }
        );
      })
      .catch(() => {});
  }, [productCode, quantity, dispatch, navigate]);

  if (!productCode) {
    return (
      <div className="w-full min-h-[60vh] flex items-center justify-center bg-white">
        <div className="max-w-md mx-4 p-6 rounded-lg border border-red-200 bg-red-50 text-center">
          <p className="text-red-700 font-medium">Product code is required</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full min-h-[60vh] flex items-center justify-center bg-white">
        <div className="max-w-md mx-4 p-6 rounded-lg border border-red-200 bg-red-50 text-center">
          <p className="text-red-700 font-medium">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <PageLoader
      message={loading ? "Loading product..." : "Redirecting to checkout..."}
    />
  );
};

export default BuyNow;
